﻿import { Utility } from '../Utility.js';
export { CitizenReport };

/**
 * Class RoadBuilderTool
 */
const CitizenReport = function () {
    // Define this
    var myCitizenReport = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // -- end private variable --------------------------------------------------------------------


    // -- begin public variable -------------------------------------------------------------------

    // Array of Layer info with citizen report
    this._arrayLayerInfo = {};

    // -- end public variable ---------------------------------------------------------------------


    // -- begin public method ---------------------------------------------------------------------

    /**
     * Build technician report information for a element
     * @param {any} layerInfo
     */
    this.BuildCitizenReportEntity = function (layerInfo) {
        const citizenreportContainerElement = $('#id-offcanvas-body-layer-detail-citizen-zone');

        citizenreportContainerElement.css('display', 'block');

        const nameEntity = 'BRAGA_TREE_REPORT';

        const offcanvasLayerDetail = $('#id-offcanvas-layer-detail');
        const emailInput = $('#id-offcanvas-body-layer-detail-citizen-form-email');
        const observationInput = $('#id-offcanvas-body-layer-detail-citizen-form-observation');
        const fileInput = $('#id-offcanvas-body-layer-detail-citizen-input-photo');
        const photoButton = $('#id-offcanvas-body-layer-detail-citizen-btn-photo');
        const dropZone = $('#id-offcanvas-body-layer-detail-citizen-input-photo-dropZone');
        const previewContainer = $('#id-offcanvas-body-layer-detail-citizen-preview-photo');
        let previewCompoment = null;
        const submitButton = $('#id-offcanvas-body-layer-detail-citizen-btn-save');
        const formElement = $('#id-offcanvas-body-layer-detail-citizen-form');

        let listFiles = [];

        if (myMapSgs._utility.mobilecheck()) {
            dropZone.hide();
            photoButton.show();
        } else {
            dropZone.show();
            photoButton.hide();
        }

        formElement.validate({
            rules: {
                citizen_email: {
                    required: true,
                    email: true
                },
                citizen_observation: {
                    required: true,
                    minlength: 5
                }
            },
            messages: {
                citizen_email: {
                    required: "Por favor insira o seu e-mail",
                    email: "Por favor, introduza um endereço de e-mail válido"
                },
                citizen_observation: {
                    required: "Por favor insira a observação",
                    minlength: "O seu observação deve ter pelo menos 5 caracteres"
                }
            },
            errorPlacement: function (error, element) {
                error.insertAfter(element);
            }
        });

        offcanvasLayerDetail.off().on('resize', () => {
            if (previewCompoment) {
                previewCompoment.refresh();
            }
        });

        emailInput.off().on('keyup', () => submitButton.attr('disabled', !formElement.valid()));

        observationInput.off().on('keyup', () => submitButton.attr('disabled', !formElement.valid()));

        photoButton.off().on('click', () => {
            fileInput.click();
        });

        fileInput.off().on('change', event => {
            for (var i = 0; i < event.target.files.length; i++) {
                listFiles.push(event.target.files[i]);
            }
            handleFiles(listFiles);
        });

        dropZone.off();

        dropZone.on('click', () => {
            fileInput[0].click();
        });

        dropZone.on('dragover', event => {
            event.preventDefault();
            dropZone.addClass('dragover');
        });

        dropZone.on('dragleave', () => {
            dropZone.removeClass('dragover');
        });

        dropZone.on('drop', event => {
            event.preventDefault();
            dropZone.removeClass('dragover');

            for (let i = 0; i < event.originalEvent.dataTransfer.files.length; i++) {
                listFiles.push(event.originalEvent.dataTransfer.files[i]);
            }
            handleFiles(listFiles);
        });

        function cleanForm() {
            listFiles = [];
            emailInput.val('');
            observationInput.val('');
            fileInput.val('');
            previewContainer.empty();
            previewContainer.css('display', 'none');
            submitButton.attr('disabled', true);
        }

        cleanForm();

        function handleFiles(files) {

            let indexImage = 0;
            previewContainer.empty();

            Array.from(files).forEach(file => {
                if (file && file.type.startsWith('image/')) {
                    const reader = new FileReader();
                    reader.onload = e => {

                        indexImage++;

                        const divImage = document.createElement("div");

                        divImage.className = "photo";
                        divImage.style.backgroundImage = `url('${e.target.result}')`;
                        divImage.setAttribute("data-role", "page");

                        const deleteButton = document.createElement('button');
                        deleteButton.textContent = 'X';
                        deleteButton.classList.add('delete-button');
                        deleteButton.addEventListener('click', (event) => {
                            $(event.target).parent().remove();
                            for (var i = 0; i < listFiles.length; i++) {
                                if (file.name == listFiles[i].name) {
                                    listFiles.splice(i, 1);
                                    previewCompoment.refresh();
                                    previewCompoment.prev();

                                    if (listFiles.length == 0) {
                                        previewContainer.css('display', 'none');
                                    }
                                    break;
                                }
                            }
                        });

                        divImage.appendChild(deleteButton);
                        previewContainer.append(divImage);

                        if (indexImage == files.length) {
                            previewContainer.css('display', 'block');

                            previewCompoment = previewContainer.kendoScrollView({
                                contentHeight: "245px",
                                enablePager: true
                            }).data("kendoScrollView");
                        }
                    };
                    reader.readAsDataURL(file);
                }
            });
        }

        formElement.off().on('submit', function (e) {

            const formInstance = this;

            myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

            e.preventDefault();

            $.ajax({
                url: `/CitizenReport/GetEntityFieldId?keyEntity=${nameEntity}`,
                async: true,
                success: function (response) {
                    if (response.result.status == "ERROR") {
                        toastr["error"]("O relatório não pôde ser criado");
                    } else {

                        let idEntity = null;

                        if (response.result.idFieldEntity == 'id') {
                            idEntity = featureInfo.feature.getId().includes('.') ? featureInfo.feature.getId().split('.')[1] : featureInfo.feature.getId();
                        } else {
                            idEntity = featureInfo.feature.getProperties()[response.result.idFieldEntity] ? featureInfo.feature.getProperties()[response.result.idFieldEntity] : null;
                        }

                        if (idEntity) {
                            var formData = new FormData(formInstance);

                            const sendData = {
                                id_entity: `${idEntity}`,
                                name_entity: nameEntity,
                                images: []
                            }

                            formData.forEach((value, key) => {
                                if (key != 'images') {
                                    if (sendData[key]) {
                                        if (!Array.isArray(sendData[key])) {
                                            sendData[key] = [sendData[key]];
                                        }
                                        sendData[key].push(value);
                                    } else {
                                        sendData[key] = value;
                                    }
                                }
                            });

                            for (let i = 0; i < listFiles.length; i++) {
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                    sendData.images.push({ [`image_${i}`]: reader.result });

                                    if (sendData.images.length === listFiles.length) {
                                        sendRequest(sendData)
                                    }
                                };
                                reader.readAsDataURL(listFiles[i]);
                            }
                        } else {
                            toastr["error"]("O relatório não pôde ser criado. Não é possível acessar o ID do elemento.");
                            myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                        }
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    toastr["error"]("O relatório não pôde ser criado");
                    myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });

            const sendRequest = (sendData) => {
                $.ajax({
                    url: '/CitizenReport/CreateCitizenReport',
                    type: 'POST',
                    data: { jsonData: JSON.stringify(sendData) },
                    async: true,
                    success: function (response) {
                        if (response.result.status == "ERROR") {
                            toastr["error"]("O relatório não pôde ser criado");
                        } else {
                            toastr["success"]("Relatório enviado com sucesso.");
                            cleanForm();
                        }
                        myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        toastr["error"]("O relatório não pôde ser criado");
                        myMapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    }
                });
            };

        });
    }

    // -- end public method -----------------------------------------------------------------------


    // -- begin private method --------------------------------------------------------------------
    // -- end private method ----------------------------------------------------------------------


    // -- begin event -----------------------------------------------------------------------------
    // -- end event -------------------------------------------------------------------------------
};

/**
* Init citizen report
* @param {object} mapSgs, map object
*/
CitizenReport.prototype.Init = function (mapSgs) {

    // Set map info
    this._mapSgs = mapSgs;

    // Get layer info
    var layerInfoObj = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "CITIZEN_REPORT", "CONFIG", "LAYER_INFO");
    if (layerInfoObj && layerInfoObj.value) {
        this._arrayLayerInfo = JSON.parse(layerInfoObj.value);
    }
};